import axios from 'axios';
import React from 'react';
import './index.css';
import authHeader from '../../services/auth-header';
import { config } from '../../constants';

function editParserConfig(){
    
}


export default class ConfigItemComponent extends React.Component{
    

    testParserConfig = (shortName) =>{
        axios.post(config.API_URL + `parser-config-test/${shortName}`,null, {headers: authHeader()}).then(
          response => {

            const sancdocs = response.data.map(
                    sancdoc => {
                        return <p>{JSON.stringify(sancdoc)}</p>
                    }
                )
                
                this.props.setSancdocs({sancdocs:sancdocs})
            }
        );
    }

    applyToElastic = (shortName) =>{
        axios.post(config.API_URL + `parser-config-apply/${shortName}`,null, {headers: authHeader()}).then(
          response => {
                console.log(response.data)
            }
        );
    }

    render(){
        
        return(
            <div className='index-list-item'>
                
                <p className='config-name'>{this.props.data.name}</p>
                <p className='config-source'>{this.props.data.source}</p>
                <p className='config-shortname'>{this.props.data.shortName}</p>
                <p className='config-datalisttype'>{this.props.data.dataListType}</p>
                <p className='config-dataurl'>{this.props.data.dataURL}</p>

                <div className='config-buttons'>
                    <button className='config-btn config-edit-btn'>/</button>
                    <button className='config-btn config-test-btn' onClick={val => this.testParserConfig(this.props.data.shortName)}>ok</button>
                    <button className='config-btn config-send-btn' onClick={val => this.applyToElastic(this.props.data.shortName)}>✔</button>
                </div>

            </div>
        );
    }
}